const cleanDirtyValue = value => {
  if (typeof value !== 'string') {
    return '';
  }
  return decodeURIComponent(value).replace(/\+/g, ' ');
};

const extractSearchValue = ({ url, searchPathname }) => {
  const myUrl = new URL(url);

  const regex = /\/filter\//;
  if (url.match(regex)) {
    const dirtyValue = myUrl.searchParams.get('q');
    return cleanDirtyValue(dirtyValue);
  }

  const searchRegex = `${searchPathname}/`;
  if (url.match(new RegExp(searchRegex))) {
    const dirtyValue = myUrl.pathname.split(searchRegex)[1];
    return cleanDirtyValue(dirtyValue);
  }
  return '';
};

export { extractSearchValue };
